import { gql } from "@apollo/client";

export const UPDATE_ENERGY_TRADING_MUTATION = gql`
  mutation UpdateClientEnergyTrading(
    $id: Int!
    $energyTradingEnabled: Boolean!
  ) {
    updateClientEnergyTrading(
      id: $id
      energyTradingEnabled: $energyTradingEnabled
    ) {
      client {
        id
        energyTradingEnabled
      }
    }
  }
`;
